export enum LoadingStatus {
    NEVER = 'NEVER',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}